module.exports = __webpack_public_path__ + "static/media/SmartShop_7-432w.20e678b9.jpg";